/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/*
// Author: Grin Zhou
*/

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Navbar } from 'react-bootstrap';
import Navigation from '../../NavigationBar';
import paths from '../../../config/path';
import './Header.css';

const AppHeader = (props) => {
  const {
    currentPage,
    pageNavList,
    headerDataId
  } = props.params;

  return (
    <header className="app-header" data-id={ headerDataId }>
        <Navbar collapseOnSelect fixedTop>
            <Navbar.Header>
                <Navbar.Brand>
                    <Link to={ paths.root.path } className="app-logo" title={'HSBC Fusion Logo'} aria-label={'HSBC Fusion Logo'}>
                    </Link>
                </Navbar.Brand>
                <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>
                <Navigation.HeaderNav
                  currentPage = { currentPage }
                  pageNavList = { pageNavList }
                />
            </Navbar.Collapse>
        </Navbar>
    </header>
  )
};

AppHeader.propTypes = {
  params: PropTypes.shape({
    onLanguageDidChange: PropTypes.func.isRequired,
    currentPage: PropTypes.string,
    currentLanguage: PropTypes.string,
    pageNavList: PropTypes.array.isRequired,
    languages: PropTypes.array,
    headerDataId: PropTypes.string.isRequired
  })
};

export default AppHeader;


// WEBPACK FOOTER //
// ./src/shared/AppHeader/components/AppHeader.js